import React from 'react'
import ContentTemplate from '../../components/common/ContentTemplate'
import SubContentTemplate from '../../components/common/SubContentTemplate'
import PageHeaderContainer from '../../containers/common/PageHeaderContainer'
import PageTitleTemplate from '../../components/common/PageTitleTemplate'
import BreadcrumbContainer from '../../containers/common/BreadcrumbContainer'
import PageTemplate from '../../components/common/PageTemplate'
import { KTWIZ_SPONSOR } from '../../constants/page'
import SponsorContainer from '../../containers/ktwiz/SponsorContainer'

const SponsorPage = () => {
  return (
    <PageTemplate className="ktwiz">
      <PageHeaderContainer title={KTWIZ_SPONSOR.title} subtitle="kt wiz와 함께하는 스폰서를 소개합니다." image={require('../../assets/img/ktwiz/sub_tit_ktwiz.png')} />
      <ContentTemplate>
        <PageTitleTemplate>
          <BreadcrumbContainer page={KTWIZ_SPONSOR} />
        </PageTitleTemplate>
        <SubContentTemplate className="ktwiz sponsor">
          <SponsorContainer />
        </SubContentTemplate>
      </ContentTemplate>
    </PageTemplate>
  )
}

export default SponsorPage
